<template>
  <v-app>
    <router-view />
    <app-overlay v-if="showOverlay" />
  </v-app>
</template>

<script>
import AppOverlay from './components/Common/AppOverlay.vue';
export default {
  name: 'App',
  components: { AppOverlay },
  computed: {
    theme() {
      return this.$vuetify.theme.dark ? 'dark' : 'light';
    },
    showOverlay() {
      return this.$store.state.showOverlay;
    },
  },
  mounted() {
    this.$vuetify.theme.dark = this.$store.state.setting.darkMode;
  },
};
</script>

<style>
@import './assets/css/appStyle.css';
</style>
